<template>
    <div class="row">
        <div class="col-10">
            <div class="card card-info">
                <div class="card-header">
                    <h4 class="card-title float-start">{{paziente.cognome}} {{paziente.nome}}</h4>
                </div>
                <div class="m-2">
                    <div class="row" align="left">
                        <div class="col-2">
                            <p><strong>Data di nascita:</strong></p>
                        </div>
                        <div class="col-10">
                            <p>{{paziente.data_nascita}}</p>
                        </div>
                    </div>
                    <div class="row" align="left">
                        <div class="col-2">
                            <p><strong>Cellulare:</strong></p>
                        </div>
                        <div class="col-10">
                            <p>{{paziente.cellulare}}</p>
                        </div>
                    </div>
                    <div class="row" align="left">
                        <div class="col-2">
                            <p><strong>Email:</strong></p>
                        </div>
                        <div class="col-10">
                           <p>{{paziente.email}}</p>
                        </div>
                    </div>   
                    <div class="row" align="left">
                        <div class="col-2">
                            <p><strong>Indirizzo:</strong></p>
                        </div>
                        <div class="col-10">
                           <p>{{paziente.indirizzo}}, {{paziente.citta}} - {{paziente.cap}}</p>
                        </div>
                    </div>  
                </div>
                        
            </div>
        </div>
        <div class="col-2">
            <div class="card card-info mb-2">
                    <a :href="route('pazienti.pdf', [paziente.id])" class="btn btn-outline-primary m-2">Genera PDF</a>                
            </div> 
        </div>
    </div>

    <div class="card card-info mt-3">
        <div class="card-header">
            <h4 class="card-title float-start">Pratiche</h4>
            <button
                type="button"
                class="btn btn-primary float-end"
                @click="isOpen = true"
            >
                Aggiungi Pratica
            </button>
        </div>
        
        <div
            class="alert alert-primary d-flex align-middle my-auto m-2 mt-2 mb-2"
            role="alert"
            v-if="paziente.pratiche.length == 0"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
            >
                <path
                    d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
            </svg>
            <div>Non sono presenti pratiche. Aggiungine una per iniziare a gestirlo :)</div>
        </div>


        <table class="table table-striped" v-if="paziente.pratiche.length > 0">
            <thead>
                <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">Data Inizio</th>
                    <th scope="col">Data Fine</th>
                    <th scope="col">Giorni Settimana</th>
                    <th scope="col">Dettagli</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pratica in paziente.pratiche" :key="pratica.id">
                    <td>{{ pratica.nome }}</td>
                    <td>{{ pratica.data_inizio }}</td>
                    <td>{{ pratica.data_fine }}</td>
                    <td>
                        <ul class="list-group">
                          <li class="list-group-item" v-for="giorno in pratica.giorni_settimana">{{giorno.nome_giorno}}</li>
                        </ul>
                    </td>
                    <td>
                        <a :href="route('pazienti.dettaglio_pratica', pratica.id)" class="btn btn-outline-dark"
                            >Dettaglio</a
                        >  
                    </td>
                    
                </tr>
            </tbody>
        </table>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card card-info mt-3">
                <div class="card-header">
                    <h4 class="card-title float-start">Diagnosi</h4>
                </div>
                
                <div
                    class="alert alert-primary d-flex align-middle my-auto m-2 mt-2 mb-2"
                    role="alert"
                    v-if="paziente.diagnosi.length == 0"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="Warning:"
                    >
                        <path
                            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                        />
                    </svg>
                    <div>Non sono presenti diagnosi. Aggiungine una per iniziare :)</div>
                </div>

                <table class="table table-striped" v-if="paziente.diagnosi.length > 0">
                    <thead>
                        <tr>
                            <th scope="col">Descrizione</th>
                            <th scope="col">Data </th>
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-for="diagnosi in paziente.diagnosi" :key="diagnosi.id">
                            <td>{{ diagnosi.descrizione }}</td>
                            <td>{{ diagnosi.data }}</td>
                            
                            
                        </tr>
                    </tbody>
                </table>

                
                <form @submit.prevent="submit_diagnosi">
                    <div class="col-md-12 text-start">
                        <label for="descrizione" class="form-label">Descrizione:</label>
                        <div class="input-group has-validation">
                            <textarea type="text" :class="{'form-control':true, 'is-invalid':errors.descrizione ? true : false}" id="descrizione" v-model="form_diagnosi.descrizione" autofocus aria-describedby="descrizioneFeedback" required></textarea>
                            <div v-if="errors.descrizione" id="descrizioneFeedback" class="invalid-feedback">
                                {{errors.descrizione}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12  text-start">
                        <label for="data" class="form-label">Data:</label>
                        <div class="input-group has-validation">
                            <input type="date" :class="{'form-control':true, 'is-invalid':errors.data_diagnosi ? true : false}" id="data_diagnosi" v-model="form_diagnosi.data_diagnosi" autofocus aria-describedby="data_diagnosiFeedback" required>
                            <div v-if="errors.data_diagnosi" id="dataFeedback" class="invalid-feedback">
                                {{errors.data_diagnosi}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start m-2">
                        <button type="submit" class="btn btn-primary" :disabled="form_diagnosi.processing">
                            Aggiungi Diagnosi
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-12">
            <div class="card card-info mt-3">
                <div class="card-header">
                    <h4 class="card-title float-start">Test</h4>
                </div>
                
                <div
                    class="alert alert-primary d-flex align-middle my-auto m-2 mt-2 mb-2"
                    role="alert"
                    v-if="paziente.test.length == 0"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="Warning:"
                    >
                        <path
                            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                        />
                    </svg>
                    <div>Non sono presenti test. Aggiungine una per iniziare :)</div>
                </div>

                <table class="table table-striped" v-if="paziente.test.length > 0">
                    <thead>
                        <tr>
                            <th scope="col">Nome</th>
                            <th scope="col">Valore</th>
                            <th scope="col">Data</th>
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-for="test in paziente.test" :key="test.id">
                            <td>{{ test.nome }}</td>
                            <td>{{ test.valore }}</td>
                            <td>{{ test.created_at }}</td>
                            
                            
                        </tr>
                    </tbody>
                </table>

                
                <form @submit.prevent="submit_test">
                    <div class="col-md-12 text-start">
                        <label for="nome" class="form-label">nome:</label>
                        <div class="input-group has-validation">
                            <textarea type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form_test.nome" autofocus aria-describedby="nomeFeedback" required></textarea>
                            <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                                {{errors.nome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="valore" class="form-label">Valore:</label>
                        <div class="input-group has-validation">
                            <textarea type="text" :class="{'form-control':true, 'is-invalid':errors.valore ? true : false}" id="valore" v-model="form_test.valore" autofocus aria-describedby="valoreFeedback" required></textarea>
                            <div v-if="errors.valore" id="valoreFeedback" class="invalid-feedback">
                                {{errors.valore}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start m-2">
                        <button type="submit" class="btn btn-primary" :disabled="form_test.processing">
                            Aggiungi Test
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-6">
            <div class="card card-info mt-3">
                <div class="card-header">
                    <h4 class="card-title float-start">Analisi</h4>
                </div>
                
                <div
                    class="alert alert-primary d-flex align-middle my-auto m-2 mt-2 mb-2"
                    role="alert"
                    v-if="paziente.analisi.length == 0"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="Warning:"
                    >
                        <path
                            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                        />
                    </svg>
                    <div>Non sono presenti analisi. Aggiungine una per iniziare :)</div>
                </div>


                <table class="table table-striped" v-if="paziente.analisi.length > 0">
                    <thead>
                        <tr>
                            <th scope="col">Nome</th>
                            <th scope="col">Valore</th>
                            <th scope="col">Data </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="analisi in paziente.analisi" :key="analisi.id">
                            <td>{{ analisi.nome }}</td>
                            <td>{{ analisi.valore }}</td>
                            <td>{{ analisi.data }}</td>
                            
                            
                        </tr>
                    </tbody>
                </table>


                <form @submit.prevent="submit_analisi">
                    <div class="col-md-12 text-start">
                        <label for="descrizione" class="form-label">Nome:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form_analisi.nome" autofocus aria-describedby="nomeFeedback" required>
                            <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                                {{errors.nome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="descrizione" class="form-label">Valore:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.valore ? true : false}" id="valore" v-model="form_analisi.valore" autofocus aria-describedby="valoreFeedback" required>
                            <div v-if="errors.valore" id="valoreFeedback" class="invalid-feedback">
                                {{errors.valore}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="data" class="form-label">Data:</label>
                        <div class="input-group has-validation">
                            <input type="date" :class="{'form-control':true, 'is-invalid':errors.data_analisi ? true : false}" id="data_analisi" v-model="form_analisi.data_analisi" autofocus aria-describedby="data_analisiFeedback" required>
                            <div v-if="errors.data_analisi" id="dataFeedback" class="invalid-feedback">
                                {{errors.data_analisi}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start m-2">
                        <button type="submit" class="btn btn-primary" :disabled="form_analisi.processing">
                            Aggiungi Analisi
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-6">
            <div class="card card-info mt-3">
                <div class="card-header">
                    <h4 class="card-title float-start">Farmaci</h4>
                </div>
                
                <div
                    class="alert alert-primary d-flex align-middle my-auto m-2 mt-2 mb-2"
                    role="alert"
                    v-if="paziente.farmaci.length == 0"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="Warning:"
                    >
                        <path
                            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                        />
                    </svg>
                    <div>Non sono presenti farmaci. Aggiungine uno per iniziare :)</div>
                </div>


                <table class="table table-striped" v-if="paziente.farmaci.length > 0">
                    <thead>
                        <tr>
                            <th scope="col">Nome</th>
                            <th scope="col">Posologia</th>
                            <th scope="col">Data Inizio</th>
                            <th scope="col">Data Fine</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="farmaco in paziente.farmaci" :key="farmaco.id">
                            <td>{{ farmaco.nome }}</td>
                            <td>{{ farmaco.posologia }}</td>
                            <td>{{ farmaco.data_inizio }}</td>
                            <td>{{ farmaco.data_fine }}</td>
                            
                            
                        </tr>
                    </tbody>
                </table>


                <form @submit.prevent="submit_farmaco">
                    <div class="col-md-12 text-start">
                        <label for="descrizione" class="form-label">Nome:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form_farmaco.nome" autofocus aria-describedby="nomeFeedback" required>
                            <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                                {{errors.nome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="descrizione" class="form-label">Posologia:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.posologia ? true : false}" id="posologia" v-model="form_farmaco.posologia" autofocus aria-describedby="posologiaFeedback" required>
                            <div v-if="errors.posologia" id="posologiaFeedback" class="invalid-feedback">
                                {{errors.posologia}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12  text-start">
                        <label for="data" class="form-label">Data Inizio:</label>
                        <div class="input-group has-validation">
                            <input type="date" :class="{'form-control':true, 'is-invalid':errors.data_inizio ? true : false}" id="data_inizio" v-model="form_farmaco.data_inizio" autofocus aria-describedby="data_inizioFeedback" required>
                            <div v-if="errors.data_inizio" id="dataFeedback" class="invalid-feedback">
                                {{errors.data_inizio}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12  text-start">
                        <label for="data" class="form-label">Data Fine:</label>
                        <div class="input-group has-validation">
                            <input type="date" :class="{'form-control':true, 'is-invalid':errors.data_fine ? true : false}" id="data_fine" v-model="form_farmaco.data_fine" autofocus aria-describedby="data_fineFeedback" >
                            <div v-if="errors.data_fine" id="dataFeedback" class="invalid-feedback">
                                {{errors.data_fine}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start m-2">
                        <button type="submit" class="btn btn-primary" :disabled="form_farmaco.processing">
                            Aggiungi Farmaco
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    


    <Create
        v-if="isOpen"
        :paziente="paziente"
        @modelStatusChanged="modalStatus"
    />

        
</template>
<script>
import Main from "@/Layouts/Main.vue";
import Create from "@/Pages/Paziente/FormPratica.vue";
import ShowButton from "@/Components/ShowButton.vue";
import EditButton from "@/Components/EditButton.vue";
import DeleteButton from "@/Components/DeleteButton.vue";
import ConfirmBox from "@/Components/ConfirmBox.vue";
import Pagination from "@/Components/Pagination.vue";

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        paziente: Object,
        flash: Object,
    },
    components: {
        Create,
        ShowButton,
        EditButton,
        DeleteButton,
        ConfirmBox,
        Pagination,
    },
    data() {
        return {
            isOpen: false,

            form_diagnosi: this.$inertia.form({
                descrizione: "" ,
                data_diagnosi: "" ,
                paziente_id: this.paziente.id
            }),

            form_test: this.$inertia.form({
                nome: "" ,
                valore: "" ,
                paziente_id: this.paziente.id
            }),

            form_analisi: this.$inertia.form({
                nome: "" ,
                valore: "" ,
                data_analisi: "" ,
                paziente_id: this.paziente.id
            }),

            form_farmaco: this.$inertia.form({
                nome: "" ,
                posologia: "" ,
                data_inizio: "" ,
                data_fine: "" ,
                paziente_id: this.paziente.id
            }),
            errors: {
               descrizione: null,
               data_diagnosi: null
            },
            
        };
    },
    methods: {
        modalStatus(status) {
            this.isOpen = status;
        },
        submit_diagnosi() {
            let route = this.route("pazienti.aggiungi_diagnosi")
            let method = 'post'
            this.form_diagnosi['post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("cognome")) {
                            toast.message = errors.cognome;
                            this.errors.cognome = errors.cognome;
                        }

                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                        if (errors.hasOwnProperty("cellulare")) {
                            toast.message = errors.cellulare;
                            this.errors.cellulare = errors.cellulare;
                        }

                        if (errors.hasOwnProperty("email")) {
                            toast.message = errors.email;
                            this.errors.email = errors.email;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form_diagnosi.reset();

                }
            });
        },
        submit_analisi() {
            let route = this.route("pazienti.aggiungi_analisi")
            let method = 'post'
            this.form_analisi['post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("cognome")) {
                            toast.message = errors.cognome;
                            this.errors.cognome = errors.cognome;
                        }

                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                        if (errors.hasOwnProperty("cellulare")) {
                            toast.message = errors.cellulare;
                            this.errors.cellulare = errors.cellulare;
                        }

                        if (errors.hasOwnProperty("email")) {
                            toast.message = errors.email;
                            this.errors.email = errors.email;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form_analisi.reset();

                }
            });
        },
        submit_farmaco() {
            let route = this.route("pazienti.aggiungi_farmaco")
            let method = 'post'
            this.form_farmaco['post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("cognome")) {
                            toast.message = errors.cognome;
                            this.errors.cognome = errors.cognome;
                        }

                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                        if (errors.hasOwnProperty("cellulare")) {
                            toast.message = errors.cellulare;
                            this.errors.cellulare = errors.cellulare;
                        }

                        if (errors.hasOwnProperty("email")) {
                            toast.message = errors.email;
                            this.errors.email = errors.email;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form_farmaco.reset();

                }
            });
        },
        submit_test() {
            let route = this.route("pazienti.aggiungi_test")
            let method = 'post'
            this.form_test['post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("cognome")) {
                            toast.message = errors.cognome;
                            this.errors.cognome = errors.cognome;
                        }

                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                        if (errors.hasOwnProperty("cellulare")) {
                            toast.message = errors.cellulare;
                            this.errors.cellulare = errors.cellulare;
                        }

                        if (errors.hasOwnProperty("email")) {
                            toast.message = errors.email;
                            this.errors.email = errors.email;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form_farmaco.reset();

                }
            });
        },

        
    },

    computed: {
        
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);

        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
    updated() {
        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
};
</script>
